export function compareDecimal(left: string, right: string): number | null {
  const pattern = /^(\d+)(?:\.(\d+))?$/
  const a = pattern.exec(String(left))
  const b = pattern.exec(String(right))
  if (!a || !b) return null
  const wholeA = a[1].replace(/^0+(?=\d)/, '')
  const wholeB = b[1].replace(/^0+(?=\d)/, '')
  if (wholeA.length !== wholeB.length)
    return wholeA.length > wholeB.length ? 1 : -1
  if (wholeA !== wholeB) return wholeA > wholeB ? 1 : -1
  const scale = Math.max((a[2] || '').length, (b[2] || '').length)
  const fractionA = (a[2] || '').padEnd(scale, '0')
  const fractionB = (b[2] || '').padEnd(scale, '0')

  return fractionA === fractionB ? 0 : fractionA > fractionB ? 1 : -1
}
